class ProductTabs extends HTMLElement {
    constructor() {
        super();
        
        this.tab = this.querySelectorAll('.tab-title');
        this.tabContents = this.querySelector('.tabs-contents');
        this.tabContent = this.querySelectorAll('.tab-content');
        this.link = this.querySelectorAll('.toggleLink');
        this.readMore = this.querySelectorAll('[data-show-more-toogle]');
        this.tabClose = this.querySelectorAll('.pdViewTab-close');
        this.isVerticalPopup = this.dataset.vertical === 'sidebar'
        this.isVerticalSidebarMobile = this.dataset.verticalMobile === 'sidebar-mobile'
        this.handleProtectedClick = this.handleProtectedClick.bind(this);

        // kristalProtectedTabClick: keep product detail tabs from bubbling into product-card overlays.
        document.addEventListener('click', this.handleProtectedClick, true);

        for (let i = 0; i < this.tab.length; i++) {
            this.tab[i].addEventListener(
                'click',
                this.tabActive.bind(this)
            );
        }
            
        for (let i = 0; i < this.link.length; i++) {
            this.link[i].addEventListener(
                'click',
                this.tabToggle.bind(this)
            );
        }

        document.addEventListener('click', e => {
            if (e.target.matches('[data-show-more-toogle]') || e.target.closest('[data-show-more-toogle]')) {
                this.readMoreReadLess(e)
            }
            else if (e.target.matches('.pdViewTab-close') || e.target.closest('.pdViewTab-close')) {
                this.productTabClose(e)

                if (this.isVerticalPopup || this.isVerticalSidebarMobile) {
                    this.handleVerticalPopupClose(e)
                }
            }
        });

        if (this.isVerticalPopup || this.isVerticalSidebarMobile) {
            document.querySelector('.background-overlay')?.addEventListener('click', this.onBackgroundClick.bind(this));
        }

        setTimeout(() => {
            if (window.innerWidth > 550) {
                const $thisContent = this.querySelector('#tab-description-mobile');
                const tabShowMore = $thisContent?.querySelector('.tab-showMore');
                const maxHeight = parseInt(tabShowMore?.dataset.desMax);
                if ($thisContent && tabShowMore && $thisContent.offsetHeight < maxHeight) {
                    tabShowMore.remove();
                }
            }
        })
    }

    handleProtectedClick(event) {
        const control = event.target.closest('.tab-title, .toggleLink, [data-show-more-toogle], .pdViewTab-close');

        if (!control || control.closest('product-tab') !== this) return;

        event.preventDefault();
        event.stopPropagation();
        if (typeof event.stopImmediatePropagation === 'function') {
            event.stopImmediatePropagation();
        }

        if (control.matches('.tab-title')) {
            this.tabActive(event, control);
        } else if (control.matches('.toggleLink')) {
            this.tabToggle(event, control);
        } else if (control.matches('[data-show-more-toogle]')) {
            this.readMoreReadLess(event, control);
        } else if (control.matches('.pdViewTab-close')) {
            this.productTabClose(event, control);

            if (this.isVerticalPopup || this.isVerticalSidebarMobile) {
                this.handleVerticalPopupClose(event, control);
            }
        }
    }
    
    tabActive(event, control = event.currentTarget){
        event.preventDefault();
        event.stopPropagation();

        var $this = control.closest('.tab-title'),
            href = $this?.getAttribute('href') || '',
            id = href.replace('#', ''),
            productSection = this.closest('[id^="ProductSection-"], .productView'),
            button_tab = productSection?.querySelector('.an-horizontal-shaking') || document.querySelector('.an-horizontal-shaking');

        if (!$this || !id) return;

        this.tab.forEach((element, index) => {
            element.classList.remove('is-open');
        });

        $this.classList.add('is-open');
        this.tabContents.classList.add('is-show');
        button_tab?.classList.add('open-tab-content');

        this.tabContent.forEach((element, index) => {
            const isActive = element.getAttribute('id') == id;
            const toggleLink = element.querySelector('.toggleLink');
            const toggleContent = element.querySelector('.toggle-content');

            element.classList.toggle('is-active', isActive);
            toggleLink?.classList.toggle('is-open', isActive);
            toggleContent?.classList.toggle('is-active', isActive);

            if (this.classList.contains('layout-horizontal') && toggleContent) {
                toggleContent.style.display = isActive ? 'block' : '';
            }
        });

        if($this.classList.contains('open-tab-content')) {
            button_tab?.classList.remove('open-tab-content');
        }

        this.checkTabShowMore(id);
    }

    tabToggle(event, control = event.currentTarget){
        event.preventDefault();
        event.stopPropagation();
        
        var $this = control.closest('.toggleLink'),
            $thisContent = $this.parentNode.nextElementSibling;

        if (!$this || !$thisContent) return;

        if ($this.classList.contains('popup-mobile') && window.innerWidth <= 551) {
            if ($($thisContent).hasClass('is-show')) {
                $($thisContent).removeClass('is-show');
            }
            else {
                $($thisContent).addClass('is-show');
            }
        }
        else {
            if(window.innerWidth <= 551 && $this.classList.contains('show-mobile')) {
                $this.classList.remove('is-open');
                $this.classList.remove('show-mobile');
                this.slideContent($thisContent, false);
            }
            else if($this.classList.contains('is-open')){
                $this.classList.remove('is-open');
                if ((this.isVerticalPopup && window.innerWidth > 550) || ($this.matches('.sidebar-mobile') && window.innerWidth <= 550)) {
                    $thisContent.classList.remove('is-show');
                    document.body.classList.remove('tab-popup-show');
                }
                else {
                    this.slideContent($thisContent, false);
                }
            } else {
                $this.classList.add('is-open');
                if ((this.isVerticalPopup && window.innerWidth > 550) || ($this.classList.contains('sidebar-mobile') && window.innerWidth <= 550)) {
                    document.body.classList.add('tab-popup-sidebar-show');
                    $thisContent.classList.add('is-show');
                    document.body.classList.add('tab-popup-show');
                } else {
                    this.slideContent($thisContent, true);
                }
            }
        }
    }

    slideContent(element, show) {
        const jq = window.jQuery || window.$;

        if (jq && jq.fn) {
            if (show) {
                jq(element).stop(true, true).slideDown('slow');
            } else {
                jq(element).stop(true, true).slideUp('slow');
            }
            return;
        }

        element.style.display = show ? 'block' : 'none';
    }

    readMoreReadLess(event, control = null){
        event.preventDefault();
        event.stopPropagation();

        var $this = control || event.target.closest('[data-show-more-toogle]'),
            id = $this.getAttribute('href').replace('#', ''),
            textShowMore = $this.getAttribute('data-show-more-text'),
            textShowLess = $this.getAttribute('data-show-less-text'),
            desMax = $this.closest('.tab-showMore')?.dataset.desMax,
            targetContent = this.querySelector(`#${id}`) || document.getElementById(`${id}`);

        if($this.classList.contains('is-less')) {
            $this.closest('.tab-showMore').classList.remove('is-less');
            $this.classList.remove('is-less');
            $this.closest('.tab-showMore').classList.add('is-show');
            $this.classList.add('is-show');
            $this.innerText = textShowMore;
            if (targetContent && desMax) targetContent.style.maxHeight = `${desMax}px`;
            this.tabContents.scrollIntoView({behavior: "smooth", block: "center", inline: "nearest"});
        } else {
            $this.closest('.tab-showMore').classList.remove('is-show');
            $this.classList.remove('is-show');
            $this.closest('.tab-showMore').classList.add('is-less');
            $this.classList.add('is-less');
            $this.innerText = textShowLess;
            if (targetContent) targetContent.style.maxHeight = 'unset';
        }
    }

    productTabClose(event, control = null) {
        event.preventDefault();
        event.stopPropagation();

        this.tabContents.classList.remove('is-show');

        this.tab.forEach((element, index) => {
            element.classList.remove('is-open');
            document.querySelector('.an-horizontal-shaking')?.classList.remove('open-tab-content');
        });

        this.tabContent.forEach((element, index) => {
            element.classList.remove('is-active');
            document.querySelector('.an-horizontal-shaking')?.classList.remove('open-tab-content');
        });

        if (window.innerWidth <= 551) {
            const $toggleContent = (control || event.target).closest('.toggle-content');

            $toggleContent?.classList.remove('is-show');
        }
    }

    checkTabShowMore(id) {
        if (window.innerWidth > 550) {
            const $thisContent = this.querySelector(`#${id}`) || document.getElementById(`${id}`);
            const tabShowMore = $thisContent?.querySelector('.tab-showMore');
            const maxHeight = parseInt(tabShowMore?.dataset.desMax);

            if ($thisContent && tabShowMore && $thisContent.offsetHeight < maxHeight) {
                tabShowMore.remove();
            }
        }
    }

    onBackgroundClick(event) {
        if (event.target.closest('.toggle-content.is-show') != null) return 
        this.querySelector('.toggleLink.is-open')?.classList.remove('is-open');
        this.querySelector('.toggle-content.is-show')?.classList.remove('is-show');
        document.body.classList.remove('tab-popup-show');
    }

    handleVerticalPopupClose(event, control = null) {
        const icon = control || event.target 
        icon.closest('.toggle-content')?.classList.remove('is-show')
        icon.closest('.tab-content')?.querySelector('.toggleLink')?.classList.remove('is-open')
        document.body.classList.remove('tab-popup-show')
    }
}

customElements.define('product-tab', ProductTabs);
